function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import React, { useState } from "react";
import styles from "./styles.css";
import DOMPurify from "dompurify";
import Icon from "@xo-union/tk-component-icons";
var ReadMoreReadLess = function ReadMoreReadLess(_ref) {
  var content = _ref.content,
    readMoreText = _ref.readMoreText,
    readLessText = _ref.readLessText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(readMoreText),
    _useState4 = _slicedToArray(_useState3, 2),
    buttonText = _useState4[0],
    setButtonText = _useState4[1];
  var toggleContent = function toggleContent() {
    if (!isExpanded) {
      setButtonText(readLessText);
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
      setButtonText(readMoreText);
    }
  };
  if (!content) return "";
  var renderToggleButtons = function renderToggleButtons() {
    return /*#__PURE__*/React.createElement("button", {
      onClick: toggleContent,
      className: styles.toggleButton,
      role: "button"
    }, buttonText, /*#__PURE__*/React.createElement(Icon, {
      name: isExpanded ? 'caret_up' : 'caret_down',
      size: "sm"
    }));
  };
  var parser = new DOMParser();
  var doc = parser.parseFromString(content, "text/html");
  var renderNodeElements = function renderNodeElements() {
    var _doc$querySelector, _doc$querySelector2, _context, _context2;
    var header = ((_doc$querySelector = doc.querySelector("h1, h2")) === null || _doc$querySelector === void 0 ? void 0 : _doc$querySelector.outerHTML) || "";
    var firstParagraph = ((_doc$querySelector2 = doc.querySelector("p")) === null || _doc$querySelector2 === void 0 ? void 0 : _doc$querySelector2.outerHTML) || "";
    var rest = doc.body && doc.body.children ? _mapInstanceProperty(_context = _sliceInstanceProperty(_context2 = _Array$from(doc.body.children)).call(_context2, 2)).call(_context, function (el) {
      return el.outerHTML;
    }).join("") : "";
    var sanitizedHeader = DOMPurify.sanitize(header);
    var sanitizedFirstParagraph = DOMPurify.sanitize(firstParagraph);
    var sanitizedRest = DOMPurify.sanitize(rest);
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: sanitizedHeader
      }
    }), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: sanitizedFirstParagraph
      }
    })), sanitizedRest && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      "data-testid": "more-or-less-container",
      className: "".concat(styles.details, " ").concat(isExpanded ? styles.expanded : styles.collapsed),
      dangerouslySetInnerHTML: {
        __html: sanitizedRest
      }
    }), renderToggleButtons()));
  };
  var renderTextContent = function renderTextContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/React.createElement("p", null, content)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, doc.body.children.length > 1 ? renderNodeElements() : renderTextContent());
};
ReadMoreReadLess.defaultProps = {
  readMoreText: "Read more",
  readLessText: "Read less"
};
export default ReadMoreReadLess;